import { render } from "./MainDetailPopup.vue?vue&type=template&id=3fb77ee1&scoped=true"
import script from "./MainDetailPopup.vue?vue&type=script&lang=js"
export * from "./MainDetailPopup.vue?vue&type=script&lang=js"

import "./MainDetailPopup.vue?vue&type=style&index=0&id=3fb77ee1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb77ee1"]])

export default __exports__